import { render, staticRenderFns } from "./ui-lightbox.vue?vue&type=template&id=ae20e66e&scoped=true"
import script from "./ui-lightbox.vue?vue&type=script&lang=js"
export * from "./ui-lightbox.vue?vue&type=script&lang=js"
import style0 from "./ui-lightbox.vue?vue&type=style&index=0&id=ae20e66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae20e66e",
  null
  
)

export default component.exports